import { render, staticRenderFns } from "./StatusUpdateDados.vue?vue&type=template&id=e6579c28&scoped=true&"
import script from "./StatusUpdateDados.vue?vue&type=script&lang=js&"
export * from "./StatusUpdateDados.vue?vue&type=script&lang=js&"
import style0 from "./StatusUpdateDados.vue?vue&type=style&index=0&id=e6579c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6579c28",
  null
  
)

export default component.exports